import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { Router } from '@angular/router';
import { ADD_PRODUCTS_ROUTE, ADD_PRODUCTS_SEARCH_ROUTE } from '@mwe/constants';
import { NavigatingBackTo } from '@mwe/models';
import { EnvironmentService, NavigationStateService } from '@mwe/services';
import { TranslateService } from '@ngx-translate/core';
import { EmptyStateComponent } from '../empty-state/empty-state.component';

@Component({
  selector: 'mwe-no-associations-found-warning',
  templateUrl: './no-associations-found-warning.component.html',
  imports: [EmptyStateComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoAssociationsFoundWarningComponent {
  private readonly router = inject(Router);
  private readonly navigationStateService = inject(NavigationStateService);
  private readonly translateService = inject(TranslateService);
  private readonly environmentService = inject(EnvironmentService);

  readonly noAddressGroupsTitle = input<string>();
  readonly noAddressGroupsText = input<string, string>('', {
    transform: value => this.translateService.instant(value, { prefix: this.prefix() }),
  });
  readonly navigatingBackTo = input<NavigatingBackTo>();
  readonly productSearchBtnClicked = output<void>();
  readonly titleToUse = computed(() => {
    return this.noAddressGroupsTitle() || this.translateService.instant('shared.noAddressGroupsError.title', { prefix: this.prefix() });
  });
  private readonly prefix = computed(() => {
    const prefixLabel = `shared.noAddressGroupsError.productPrefix_${this.environmentService.getPortalCustomerType()}`;
    return this.translateService.instant(prefixLabel);
  });

  navigateToProductSearch(): void {
    this.productSearchBtnClicked.emit();
    this.navigationStateService.addNavigatingBackTo(this.navigatingBackTo());
    this.router.navigateByUrl(`/${ADD_PRODUCTS_ROUTE}/${ADD_PRODUCTS_SEARCH_ROUTE}`);
  }
}
